import { motion } from "framer-motion";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Home, ArrowRight } from "lucide-react";
import { vendorType, vendorDescriptions, vendorIcons } from "@/constants/vendorType";
import { useNavigate } from "react-router-dom"; 
import { useDispatch } from "react-redux";
import { setFilters } from "@/redux/vendor.search.slice";
import { regions } from "@/constants/regions";

// const regions = ["All Regions", "Sydney", "Melbourne", "Brisbane"];

export function CategoriesSection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedRegion, setSelectedRegion] = useState("All Regions");

  const handleRegionClick = (region) => {
    setSelectedRegion(region.name);
    dispatch(
      setFilters({
        vendorType: [],
        rating: null,
        serviceType: [],
      })
    );
    localStorage.setItem("homePage", "false");

    if (region.location) {
      localStorage.setItem("selectedVendorLocation", JSON.stringify(region.location));
    } 
    // else {
    //   localStorage.removeItem("selectedVendorLocation"); // Clear if "All Regions"
    // }
    navigate("/customer/search-brokers");
  };

  const handleCardClick = (vendor) => {
    dispatch(
      setFilters({
        vendorType: vendor ? [vendor] : [],
        rating: null,
        serviceType: [],
      })
    );
    navigate(`/customer/search-brokers`);
  };

  return (
    <section id="categories" className="py-20 category-gradient-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Browse by Category in Your Region
          </h2>
          <p className="text-xl text-gray-600">
            Find the right professional for your home buying journey
          </p>
        </motion.div>

        {/* Region Selection */}
        <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
      className="flex flex-wrap justify-center gap-4 mb-12"
    >
      {regions.map((region) => (
        <Button
          key={region.name}
          onClick={() => handleRegionClick(region)}
          variant={selectedRegion === region.name ? "default" : "outline"}
          className={
            selectedRegion === region.name
              ? "bg-[rgb(106,0,244)] text-white hover:bg-[rgb(90,0,210)]"
              : "text-[rgb(106,0,244)] border-[rgb(106,0,244)] hover:bg-[rgb(106,0,244)] hover:text-white"
          }
        >
          {region.name}
        </Button>
      ))}
    </motion.div>

        {/* Professional Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {vendorType.map((vendor, index) => {
            const IconComponent = vendorIcons[vendor] || Home;
            return (
              <motion.div
                key={vendor}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -8 }}
              >
                <Card className="h-full hover:shadow-2xl transition-all duration-300 border-0 bg-white/80 backdrop-blur-sm hover:bg-white/90  cursor-pointer"
                 onClick={() => handleCardClick(vendor)}>
                  <CardContent className="p-8">
                    <div className="w-20 h-20 bg-gradient-to-br from-purple-100 to-blue-100 rounded-2xl flex items-center justify-center mb-6">
                      <IconComponent className="text-purple h-10 w-10" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">
                      {vendor}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {vendorDescriptions[vendor]}
                    </p>
                    <Button
                      variant="ghost"
                      className="text-[rgb(106,0,244)] hover:text-purple/80 p-0 font-semibold"
                    >
                      {/* Find {vendor.split(" ")[0]}s{" "} */}
                      Find an expert
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
